import { Link } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';

function CTASection({
  eyebrow = 'Ready to move forward?',
  title = "Let's Build a Smarter Business Together.",
  text = 'Book a free consultation and discover how QASHQ can align your business operations with the right technology.',
  primaryLabel = 'Book a Free Consultation',
  primaryTo = '/contact',
  secondaryLabel,
  secondaryTo = '/services',
  variant = 'navy',
}) {
  const ref = useScrollReveal();

  return (
    <section className={`cta-banner cta-banner--${variant}`} aria-label="Call to action">
      <div className="container">
        <div ref={ref} className="cta-banner-inner reveal-on-scroll">
          {eyebrow && <p className="cta-banner-eyebrow">{eyebrow}</p>}
          <h2 className="cta-banner-title">{title}</h2>
          {text && <p className="cta-banner-text">{text}</p>}
          <div className="cta-banner-actions">
            <Link to={primaryTo} className="btn btn-secondary cta-banner-btn">
              {primaryLabel}
            </Link>
            {secondaryLabel && (
              <Link to={secondaryTo} className="btn btn-outline-light cta-banner-btn">
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
